import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const PropertyIntelDashboard = React.lazy(
  () => import("./PropertyIntelDashboard"),
);
const PropertyIntelMap = React.lazy(
  () => import("./PropertyIntelMap"),
);

const propertyIntelModuleConfig: ModuleConfig = {
  id: "property-intel",
  name: "Property Intel",
  description:
    "Brisbane property heat-map combining CC-BY government data (cadastre, statutory valuations, crime stats, demographics) into a single Leaflet interface.",
  version: "0.1.0",
  enabled: true,
  category: "research",
  order: 55,
  icon: "🏘️",
  color: "teal",

  routes: [
    {
      path: "/property-intel",
      component: PropertyIntelDashboard,
      exact: true,
      permissionLevel: "view",
      useLayout: true,
      layoutOptions: { maxW: "container.xl" },
    },
    {
      path: "/property-intel/map",
      component: PropertyIntelMap,
      exact: true,
      permissionLevel: "view",
      useLayout: true,
      layoutOptions: { noContainer: true },
    },
  ],

  navigation: [
    {
      label: "Dashboard",
      path: "/property-intel",
      icon: "📊",
      permissionLevel: "view",
    },
    {
      label: "Map",
      path: "/property-intel/map",
      icon: "🗺️",
      permissionLevel: "view",
    },
  ],

  // Permissions block intentionally empty — backend permissions.ts is the SSOT.
  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },
};

export default propertyIntelModuleConfig;
